import { Bluex, Greenx, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Box from "@mui/material/Box";

const ProgressBarBackground = styled(Box)({
  background: Bluex["50"],
  width: "100%",
  height: Spacing["500"],
});

const ProgressBarFiller = styled(Box)({
  background: Greenx["200"],
  height: Spacing["500"],
  transition: "width 300ms ease-in-out",
  willChange: "width",
});

interface IProgressBarProps {
  width: number;
}

export function ProgressBar({ width }: Readonly<IProgressBarProps>) {
  return (
    <ProgressBarBackground>
      <ProgressBarFiller style={{ width: `${width}%` }} />
    </ProgressBarBackground>
  );
}
